<template>
  <div>
    
    <br />
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="roleName">Role Name:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="role1.roleName"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="activeStr">Is Active:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="role1.activeStr"
        ></InputText>
      </div>
    </div>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="createdByName">Created By:</label>
        <InputText
          class="clearer"
          v-if="role1.mbpDept"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="role1.createdByName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="updatedByName">Updated By:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="role1.updatedByName"
        ></InputText>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  created() {
    this.role1 = {...this.role}
  },
  props: ["role"],
  data: () => ({
    role1: {}
  }),
  watch: {
    role(val) {
      this.role1 = val
    },
    role1() {
      if (this.role1.active && !this.role1.activeStr) {
        this.role1.activeStr = this.role1.active ? 'Yes' : 'No'
      }
    }
  }
}

</script>